import { WhatToDoRaw, WhatToDo } from "./types/whatToDo";
import { fetchWithRetry } from "../client";
import { cmsLang, type Locale } from "@/i18n/config";

export async function fetchWhatToDo(lang: Locale): Promise<WhatToDo[]> {
  const res = await fetchWithRetry<{ data: WhatToDoRaw[] }>(
    `/what-to-do?lang=${cmsLang(lang)}`
  );
  return res.data.map(
    (item): WhatToDo => ({
      id: item.id,
      nombre: item.nombre,
      imagen: item.imagen,
      url: item.url,
    })
  );
}
